import { useCredits } from '../context/CreditsContext';
import { Coins } from 'lucide-react';

const CreditsDisplay = ({ onClick }) => {
  const { credits, loading } = useCredits();

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-1.5 bg-blue-50 hover:bg-blue-100 rounded-full transition-colors"
    >
      <Coins className="h-4 w-4 text-blue-600" />
      <span className="text-sm font-semibold text-blue-700">
        {loading ? '...' : credits}
      </span>
    </button>
  );
};

export default CreditsDisplay;